module.exports = __webpack_public_path__ + "img/3.07c66c4f.png";